interface ReadingBottomNavProps {
  onPrevious: () => void
  onNext: () => void
  onDone: () => void
  isFirstVerse: boolean
  isLastVerse: boolean
  goalCompleted: boolean
}

const ReadingBottomNav = ({
  onPrevious,
  onNext,
  onDone,
  isFirstVerse,
  isLastVerse,
  goalCompleted,
}: ReadingBottomNavProps) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] glass-morphism border-t-0 rounded-t-3xl z-20">
      <div className="flex items-center justify-center gap-2 sm:gap-4 px-4 sm:px-6 py-4 max-w-lg mx-auto">
        {/* Previous button */}
        <button
          onClick={onPrevious}
          disabled={isFirstVerse}
          className="flex items-center justify-center w-12 h-12 rounded-xl bg-surface-subtle border border-main text-main disabled:opacity-30 hover:bg-surface-strong active:scale-95 transition-all"
          aria-label="Önceki ayet"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {/* Done button */}
        <button
          onClick={onDone}
          className={`flex-1 h-12 rounded-xl font-bold text-sm tracking-tight transition-all active:scale-95 shadow-lg ${
            goalCompleted
              ? 'bg-success text-white shadow-success/20'
              : 'bg-brand-secondary text-white shadow-brand-secondary/20 hover:brightness-110'
          }`}
        >
          {goalCompleted ? '🎉 Hedef Tamamlandı!' : 'TAMAMLADIM'}
        </button>

        {/* Next button */}
        <button
          onClick={onNext}
          disabled={isLastVerse}
          className="flex items-center justify-center w-12 h-12 rounded-xl bg-surface-subtle border border-main text-main disabled:opacity-30 hover:bg-surface-strong active:scale-95 transition-all"
          aria-label="Sonraki ayet"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default ReadingBottomNav
